<template>
  <div>
    <h1>Ничево</h1>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
